import * as React from 'react';

import SignTinycon16 from './SignTinycon16';

export const signTinycon16 = () => <SignTinycon16 />;

export default {
    title: 'Icon/Line/SignTinycon16',
    component: SignTinycon16,
    parameters: {
        notes: "`import SignTinycon16 from 'box-ui-elements/es/icon/line/SignTinycon16';`",
    },
};
